import { createSelector } from '@reduxjs/toolkit'
import { bblApi, PortalTypesEnum } from 'api/bbl'

const selector = bblApi.endpoints.getBbl.select()
const bblSettingsSelector = bblApi.endpoints.getBblSettings.select()
const bblApplicationSelector = bblApi.endpoints.getBblApplications.select()

export const getBbl = selector

export const getBblSettings = createSelector(
  bblSettingsSelector,
  (state) => state.data
)
export const getBblUrls = createSelector(
  bblSettingsSelector,
  (state) => state.data?.urls
)
export const isForkjopActive = createSelector(
  bblApplicationSelector,
  ({ data }) => data?.some(({ name }) => name === PortalTypesEnum.Forkjop)
)

export const isMypageActive = createSelector(
  bblApplicationSelector,
  ({ data }) => data?.some(({ name }) => name === PortalTypesEnum.MinSide)
)

export const getBblDisplayNames = createSelector(
  bblSettingsSelector,
  (state) => ({
    portalShort: state.data?.displayNames?.portalDisplayNameShort || 'Portalen',
    portal: state.data?.displayNames?.portalDisplayName || 'Portalen',
    myPage: state.data?.displayNames?.myPageDisplayName || 'Min side',
    myPageShort: state.data?.displayNames?.myPageDisplayNameShort || 'Min side',
  })
)
